import { useMissionStore } from '../../../shared/store/useMissionStore';
import icon from '@/assets/downloadable-content.png';

export const DownloadArea = () => {
  const mission = useMissionStore((state) => state.mission);

  if (!mission || !mission?.missionDownloadArea?.downloadLink?.length) return null;

  return (
    <div className="rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
      {mission?.missionDownloadArea?.header && (
        <div className="mb-sh-15 flex items-center gap-sh-15">
          {mission.missionDownloadArea.header.icon?.url && (
            <img src={mission.missionDownloadArea.header.icon.url} alt="" className="size-[38px]" />
          )}
          <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{mission.missionDownloadArea.header.title}</h3>
        </div>
      )}
      {mission?.missionDownloadArea?.downloadLink?.map((link) => {
        if (!link) return null;
        return (
          <li key={link?.title} className="flex flex-col !pb-4 pl-0 text-sh-sm last:!pb-0">
            <a
              href={link?.content?.url}
              rel="noreferrer"
              target="_blank"
              className="flex items-center font-bold text-black-100">
              <img src={icon} className="mr-1" alt="downloadable icon" />
              {link?.title}
            </a>
            <ol className="!m-0 !pl-6 text-sh-xxs">{link?.description}</ol>
          </li>
        );
      })}
    </div>
  );
};
